import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index')
  },
  {
    path: '/sub-index/:type/:title',
    name: 'subIndex',
    component: ()=>import('../views/sub-index')
  },
  {
    path: '/article-list/:type',
    name: 'articleList',
    component: () => import('../views/article/list')
  },
  {
    path: '/article-vip/:id',
    name: 'articleVip',
    component: () => import('../views/article/vip')
  },
  {
    path: '/article-page/:id',
    name: 'articlePage',
    component: () => import('../views/article/page')
  },
  {
    path: '/loginRegist',
    name: 'lr',
    component: () => import('../views/loginRegist')
  },
  {
    path: '*',
    name: 'error',
    component: ()=>import('../views/error/404')
  },
  {
    path: '/other',
    redirect: '/other/experts',
    component: ()=>import('../views/other'),
    children: [
      {
        path: 'experts',
        name: 'experts',
        component: ()=>import('../views/other/experts'),
        meta: {
          title: '专家库'
        }
      },
      {
        path: 'download',
        name: 'download',
        component: ()=>import('../views/other/download'),
        meta: {
          title: '资料下载'
        }
      },
      {
        path: 'certificate',
        name: 'certificate',
        component: ()=>import('../views/other/certificate'),
        meta: {
          title: '证书查询'
        }
      },
      {
        path: 'join',
        name: 'join',
        component: ()=>import('../views/other/join'),
        meta: {
          title: '申请入会'
        }
      },
      {
        path: 'standards',
        name: 'standards',
        component: ()=>import('../views/other/standards'),
        meta: {
          title: '申报标准'
        }
      },
      {
        path: 'suggestion',
        name: 'suggestion',
        component: ()=>import('../views/other/suggestion'),
        meta: {
          title: '投诉/建议'
        }
      },
      {
        path: 'consult',
        name: 'consult',
        component: ()=>import('../views/other/consult'),
        meta: {
          title: '申请/咨询'
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes
})
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      console.error(err);
    }
  });
};
router.beforeEach((to, from, next) => {
  if(to.path === '/loginRegist') {
    var time = localStorage.getItem('loginTime')
    if(time) next('/')
    else next()
  }
  next()
})
export default router
